import script from "./DueDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./DueDatePicker.vue?vue&type=style&index=0&id=9f417eea&lang=css"

const __exports__ = script;

export default __exports__